/*
** 底部
*/
import React, { Component } from 'react';

import '../index.css';

export default class Footer extends Component{

    constructor(props){

        super(props);

        this.state = {}
    }

    componentWillMount() {}

    // 初始化render之后执行一次，在这个方法内可以访问任何组件
    componentDidMount() {}

    render(){
        return(
           <div className = 'footer'>
                {/* <div>
                    <div>
                        <p className="title">服务支持</p>
                        <p>开发文档</p>
                        <p>物料下载</p>
                    </div> 
                    <div>
                        <p className="title">友情链接</p>
                        <p>彩之云开放平台</p>
                    </div>
                    <div>
                        <p className="title">客服帮助</p>
                        <p>自助服务专区</p>
                        <p>客服：10101778（周一到周五 09:00-17:30)</p>
                    </div>   
                </div> */}

                <div>
                    <p>Copyright © 2019 深圳市彩之云网络科技有限公司 | ICP证: 粤ICP备13038151号-2</p>
                </div>
           </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/page/App/common/Footer.jsx